<template>
  <div class="ma-0 pa-4 hojt">
    <v-row>
      <v-col cols="12">
        <p class="headline grey--text text--{darken}-{4}">
          Find begivenheder i nærheden af dig
        </p>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col class="d-flex" cols="12">
        <v-autocomplete
          item-color="light-blue"
          color="light-blue"
          v-model="selectedArea"
          v-bind:items="areas"
          hide-no-data
          item-text="kommune"
          item-value="kode"
          label="Vælg kommune"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <!-- Startdate -->
    <v-row>
      <v-col class="d-flex" cols="12">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          color="light-blue"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="computedDateFormatted"
              label="Vælg en dato fra og med:"
              color="light-blue"
              persistent-hint
              append-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            color="light-blue"
            no-title
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <!-- //startdate -->

    <!-- Enddate -->
    <v-row>
      <v-col class="d-flex" cols="12">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          color="light-blue"
          item-comlor="light-blue"
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="computedEndDateFormatted"
              label="Vælg en dato til og med:"
              color="light-blue"
              item-color="light-blue"
              persistent-hint
              append-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="enddate"
            color="light-blue"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="d-flex" cols="12">
      <v-col cols="12" lg="12" class="mb-12">
        <v-select
          v-model="selectedEventTypes"
          :items="eventTypes"
          label="Hvad vil du opleve?"
          hint="Vælg kategori"
          item-color="light-blue"
          color="light-blue"
          persistent-hint
          multiple
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle">
              <v-list-item-action>
                <v-icon
                  :color="selectedEventTypes.length > 0 ? 'light-blue' : ''"
                  >{{ icon }}</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Vælg alt</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:append-item> </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="hei">
        <v-btn block outlined color="light-blue" darken v-on:click="urlMaker"
          >Søg
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-alert v-if="noresult" type="warning">
          Vi fandt ikke noget, der passer på din søgning.
        </v-alert>
      </v-col>
    </v-row>
    <v-spacer class="extra-height"></v-spacer>
    <v-row class="mb-0">
      <v-col cols="12">
        <p class="subtitle-2 grey--text text--{darken}-{4}">
          Skal dit arrangement med på listen?
        </p>
      </v-col>
    </v-row>
    <v-row class="mt-0" align="center" justify="space-around">
      <v-btn tile color="success" @click="gotolink">
        <v-icon left> mdi-pencil </v-icon>
        Indtast event
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SearchForm",
  data: (vm) => ({
    selectedArea: "751",
    noresult: false,
    selectedEventTypes: [],
    eventTypes: [
      "Musik",
      "Kunst",
      "Udflugt",
      "Fællesspisning",
      "Undervisning",
      "Scene",
      "Teater",
      "Foredrag",
      "Film",
      "Sportsturnering",
      "Motion",
      "Generalforsamling",
      "Diverse",
    ],
    areas: undefined,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    enddate: vm.getNextWeek(new Date()),
    enddateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    modal: false,
    url: undefined,
    jewel: undefined,
  }),
  async mounted() {
    const url = "https://eventinfo.kodus.dk/api/koder";
    const response = await fetch(url);
    this.areas = await response.json();

    this.$root.$on("noresult", (val) => {
      this.noresult = val;
    });
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedEndDateFormatted() {
      return this.formatDate(this.enddate);
    },
    likesAllEvents() {
      return this.selectedEventTypes.length === this.eventTypes.length;
    },

    icon() {
      if (this.likesAllEvents) return "mdi-close-box";
      if (this.likesSomeFruit) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    eventInfoLink() {
      var link =
        window.location != window.parent.location
          ? document.referrer
          : document.location.href;

      return link + "eventinfo";
    },
  },

  watch: {
    date(val) {
      var dick = val;
      dick++;
      this.dateFormatted = this.formatDate(this.date);
      val = dick;
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllEvents) {
          this.selectedEventTypes = [];
        } else {
          this.selectedEventTypes = this.eventTypes.slice();
        }
      });
    },
    gotolink() {
      window.open(this.eventInfoLink, "_blank");
    },
    getNextWeek(today) {
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 7
      );
      return nextweek.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    urlMaker: function () {
      let api = "https://eventinfo.kodus.dk/api/events";
      let url =
        api +
        "/" +
        this.selectedArea +
        "/" +
        this.date +
        "/" +
        this.enddate +
        "/" +
        this.selectedEventTypes;
      this.url = url;
      this.$root.$emit("newUrl", this.url);
    },
  },
};
</script>
<style scoped>
.hojt {
  height: 100%;
  overflow: auto;
}
.extra-height {
  height: 60px;
}
.hei {
  min-height: 140px;
}
.font {
  font-family: "Roboto Condensed", sans-serif;
}
.gotolink {
  cursor: pointer;
}
</style>
